import React, { useState, useRef, useEffect } from "react";
import { FaComments, FaTimes, FaPaperPlane, FaRobot } from "react-icons/fa";

const BOT_NAME = "TechBot";

const SUGGESTIONS = [
  "Çfarë shërbimesh ofroni?",
  "Sa kushton një projekt?",
  "Sa kohë zgjat zhvillimi?",
  "Si mund t'ju kontaktoj?",
  "Çfarë teknologjish përdorni?",
  "Si funksionon procesi i një projekti?",
  "A ofroni UI/UX design?",
  "A bëni dyqane online (e-commerce)?",
  "Çfarë mbështetjeje ofroni pas lançimit?",
  "A punoni me startup ose ide të reja?",
  "A nënshkruani NDA?",
  "A mund të rifitoj një projekt ekzistues?",
  "A ofroni hosting dhe domain?",
  "A bëni SEO dhe marketing?",
  "Ku ndodheni?",
  "Si filloj një projekt me ju?",
  "A bëni aplikacione iOS dhe Android?",
  "Cilat metoda pagese pranoni?",
  "A ofron konsultim falas?",
  "A bëni integrime me API?",
  "A punoni me klientë ndërkombëtarë?",
  "A ofroni trajnim pas dorëzimit?",
];

const FAQ = [
  {
    keywords: ["shërbim", "ofron", "bëni", "punoni", "specializim", "çfarë", "ofroni", "keni", "mundësi", "aktivitet", "oferta"],
    answer:
      "Ne ofrojmë: **Zhvillim Web** (faqe, platforma, e-commerce), **Aplikacione Mobile** (iOS & Android), **UI/UX Design** dhe **Konsulencë Teknologjike**. Çdo projekt fillon me një analizë falas të nevojave tuaja.",
  },
  {
    keywords: ["çmim", "kosto", "kushton", "buxhet", "tarifë", "pagesë", "sa", "vlera", "ofertë", "ç'mim", "shumë", "lirë", "shtrenjtë"],
    answer:
      "Çmimet varen nga kompleksiteti i projektit. Një faqe prezantuese fillon nga ~500€, ndërsa platforma më komplekse mund të arrijnë 3 000€+. Për më shumë informacione na kontaktoni në: kontakt@techtalent-ks.com",
  },
  {
    keywords: ["kohë", "zgjat", "afat", "deadline", "dorëzim", "kur", "shpejt", "sa gjatë", "ditë", "javë", "muaj", "periudhë"],
    answer:
      "Kohëzgjatja tipike: faqe prezantuese 1–2 javë, aplikacion mobil bazik 4–8 javë, platforma komplekse 2–4 muaj. Gjatë takimit fillestar ju japim një orar të detajuar.",
  },
  {
    keywords: ["kontakt", "email", "telefon", "takim", "bisedë", "flas", "shkruaj", "ju dërgoj", "mesazh", "whatsapp", "instagram", "social"],
    answer:
      "Mund të na shkruani në **kontakt@techtalent-ks.com** ose të plotësoni formularin në seksionin Kontakt. Përgjigjem zakonisht brenda një dite pune.",
  },
  {
    keywords: ["teknologji", "tech", "stack", "react", "flutter", "framework", "javascript", "typescript", "python", "node", "next", "swift", "kotlin", "aws", "vercel", "database", "backend", "frontend"],
    answer:
      "Punojmë me teknologjitë moderne: **React** dhe **Next.js** për web, **Flutter** dhe **Swift** për mobile, **Node.js / Python** për backend, dhe **AWS / Vercel** për hosting.",
  },
  {
    keywords: [
      "proces",
      "hapat",
      "si funksionon",
      "nga fillon",
      "faza",
      "workflow",
    ],
    answer:
      "Zakonisht: **1)** takim / analizë nevojash, **2)** ofertë & plan, **3)** dizajn & prototip, **4)** zhvillim me përditësime javore, **5)** testim, **6)** lançim & dokumentim. Ju mbajmë të informuar në çdo hap.",
  },
  {
    keywords: ["ui/ux", "dizajn", "design", "ndërfaqe", "figma", "prototip"],
    answer:
      "Po — ofrojmë **UI/UX design** (hulumtim i shkurtër, rrjedha e përdoruesit, ekrane në Figma dhe prototip klikues) para se të fillojë zhvillimi, që produkti të dalë i qartë dhe profesional.",
  },
  {
    keywords: [
      "e-commerce",
      "ecommerce",
      "dyqan online",
      "shitje online",
      "shopify",
      "porosi online",
    ],
    answer:
      "Po, ndërtojmë **dyqane online** dhe platforma me shportë, pagesa (Stripe etj.), menaxhim porosish dhe panel administrimi. Buxheti dhe afati varen nga numri i produkteve dhe integrimeve.",
  },
  {
    keywords: [
      "startup",
      "start-up",
      "mvp",
      "ide e re",
      "ide të reja",
      "faza e hershme",
    ],
    answer:
      "Po — shpesh punojmë me **startup** dhe ide në fazë të hershme: MVP i shpejtë, validim në treg dhe rrugë të qarta për skalim. Fillojmë me një bisedë për prioritetet dhe buxhetin.",
  },
  {
    keywords: [
      "portfolio",
      "shembull",
      "shembuj",
      "demo",
      "referenc",
      "projekte",
      "punime",
      "çfarë keni bërë",
      "projekt të mëparshëm",
      "trokit",
      "kthimi",
    ],
    answer:
      "Shikoni seksionin **Portfolio** në faqe — kemi projekte si Trokit (app iOS), Kthimi NTSH (katalog web) dhe aplikacione të tjera. Me kënaqësi ju tregojmë më shumë gjatë një thirrjeje.",
  },
  {
    keywords: ["ristrukturim", "refaktor", "kod ekzistues", "legacy", "projekt ekzistues", "migrim"],
    answer:
      "Po — mund të **ristrukturojmë, pastrojmë ose migrojmë** projekte ekzistuese (web ose mobile). Fillojmë me një analizë të shkurtër të kodit dhe problemeve, pastaj propozojmë plan dhe kosto.",
  },
  {
    keywords: ["team", "ekip", "kush", "punojnë", "zhvillues", "sa persona", "staf", "anëtar", "kompani", "agjensi"],
    answer:
      "Jemi një ekip i vogël por me eksperiencë të madhe — zhvillues full-stack, dizajnerë UI/UX dhe menaxherë projekti. Cilësia dhe komunikimi me klientin janë prioritetet tona kryesore.",
  },
  {
    keywords: ["garanci", "mbështetje", "support", "mirëmbajtje", "pas", "bug", "problem pas", "ndihmë", "çështje", "riparim", "gabim"],
    answer:
      "Ofrojmë **30 ditë mbështetje falas** pas dorëzimit të projektit. Pas kësaj periudhe kemi paketa mirëmbajtjeje mujore. Kurrë nuk lëmë klientin pa ndihmë.",
  },
  {
    keywords: ["nda", "konfidencial", "sekret", "privat"],
    answer:
      "Po, nënshkruajmë **NDA (Marrëveshje Konfidencialiteti)** para çdo zbulimi teknik të detajuar. Privatësia e ideve tuaja është prioritet.",
  },
  {
    keywords: ["hosting", "domain", "server", "host", "deploy", "publikim", "lançim faqe"],
    answer:
      "Po — ofrojmë **hosting dhe konfigurim domain** si pjesë e paketës së projektit. Punojmë me **Vercel, AWS dhe Hostinger**. Pas lançimit ju mbështesim edhe për rinovimet dhe mirëmbajtjen e serverit.",
  },
  {
    keywords: ["seo", "marketing", "google", "pozicionim", "kërkim", "optimizim", "reklam"],
    answer:
      "Ofrojmë **SEO bazik** (meta tags, struktura, shpejtësi, sitemap) si pjesë e çdo projekti web. Për marketing të avancuar (Google Ads, Social Media) bashkëpunojmë me partnerë të specializuar — na pyesni për detaje.",
  },
  {
    keywords: ["ku ndodh", "adres", "zyrë", "lokacion", "vendndodh", "kosov", "prishtinë", "shqipëri"],
    answer:
      "Jemi të bazuar në **Kosovë** dhe punojmë me klientë nga e gjithë rajoni dhe bota. Takimet i bëjmë **online (Zoom/Meet)** ose fizikisht në Prishtinë — sipas preferencës suaj.",
  },
  {
    keywords: ["si fillon", "si filloj", "hap i parë", "nga fillon", "si nis", "si startoj", "fillim"],
    answer:
      "E thjeshtë: **1)** Na shkruani në kontakt@techtalent-ks.com ose plotësoni formularin, **2)** Caktojmë një takim fillestar falas (30 min), **3)** Marrim nevojat tuaja dhe dërgojmë ofertë brenda 48 orësh. Pa asnjë detyrim!",
  },
  {
    keywords: ["ios", "android", "mobil", "app", "aplikacion mobil", "smartphone", "telefon"],
    answer:
      "Ndërtojmë **aplikacione mobile** për iOS dhe Android — native (**Swift** për iOS, **Kotlin** për Android) ose cross-platform me **Flutter**. Zgjedhja varet nga buxheti, afati dhe nevojat specifike.",
  },
  {
    keywords: ["pagesë", "pagoj", "metodë pagese", "transfer", "bankë", "paypal", "faturë", "invoice"],
    answer:
      "Pranojmë pagesa me **transfer bankar, PayPal dhe Wise**. Zakonisht struktura është: **30% avans** para fillimit, **40% në fazën e mesme** dhe **30% pas dorëzimit**. Lëshojmë faturë për çdo pagesë.",
  },
  {
    keywords: ["konsultim falas", "konsultë", "takim falas", "pa pagesë", "analizë falas", "ofertë falas"],
    answer:
      "Po — **takimi fillestar dhe analiza e nevojave janë plotësisht falas**. Gjatë kësaj bisede kuptojmë qëllimin tuaj dhe ju japim një vlerësim të parë të kohës dhe kostos, pa asnjë detyrim.",
  },
  {
    keywords: ["api", "integrim", "integroj", "webhook", "third party", "lidhje", "crm", "erp", "payment gateway"],
    answer:
      "Po — integrojmë **API të palëve të treta**: sisteme pagese (Stripe, PayPal), CRM, ERP, platforma social media, shërbime emaili dhe çdo API tjetër me dokumentacion. Na tregoni çfarë ju duhet.",
  },
  {
    keywords: ["ndërkombëtar", "jashtë vendit", "diasporë", "abroad", "foreign", "overseas", "gjuhë", "anglisht"],
    answer:
      "Po — punojmë me klientë **ndërkombëtarë** dhe komunikojmë në **shqip dhe anglisht**. Takimet online na mundësojnë bashkëpunim të pa kufizuar gjeografik.",
  },
  {
    keywords: ["trajnim", "udhëzim", "mëso", "dokumentim", "manual", "si e përdor", "pas dorëzimit"],
    answer:
      "Pas çdo projekti ofrojmë **dokumentim teknik dhe trajnim bazik** (video ose sesion live) për të përdorur panelin dhe funksionet kryesore. Dëshironi trajnim të zgjeruar? Na pyesni për paketën e dedikuar.",
  },
  {
    keywords: ["rishikim", "ndryshim", "revision", "korrigjim", "feedback", "ndryshoj", "modifikim"],
    answer:
      "Gjatë zhvillimit kemi **raunde rishikimi** të planifikuara pas çdo faze. Ndryshimet brenda scope-it fillestar janë të përfshira — ndryshimet shtesë vlerësohen veçmas dhe diskutohen me ju para zbatimit.",
  },
  {
    keywords: ["kosto mujore", "abonament", "plan mujor", "ongoing", "mirëmbajtje mujore", "paketa"],
    answer:
      "Kemi **paketa mirëmbajtjeje mujore** që përfshijnë: monitorim, backup, përditësime sigurie dhe orë mbështetjeje. Çmimet fillojnë nga **49€/muaj** — na kontaktoni për të gjetur paketën e duhur.",
  },
  {
    keywords: ["cilësi", "standard", "kod i pastër", "best practice", "performancë", "shpejtësi faqe"],
    answer:
      "Çdo projekt kalon nëpër **testim të plotë** (funksional, performancë, cross-browser, mobile). Shkruajmë **kod të pastër dhe të dokumentuar**, ndjekim best practices dhe optimizojmë shpejtësinë e ngarkimit.",
  },
  {
    keywords: ["testimonial", "vlerësim", "opinion", "review", "çfarë thonë", "klient i kënaqur"],
    answer:
      "Klientët tanë e vlerësojnë komunikimin e shpejtë, cilësinë e produktit dhe mbështetjen pas dorëzimit. Shikoni seksionin **Testimoniale** në faqe ose na pyesni — me kënaqësi ju lidhim me klientë të mëparshëm.",
  },
];

function getReply(input) {
  const lower = input.toLowerCase();
  for (const entry of FAQ) {
    if (entry.keywords.some((kw) => lower.includes(kw))) {
      return entry.answer;
    }
  }
  return "Faleminderit për pyetjen! Për çdo informacion më specifik, ju lutem shkruani në **kontakt@techtalent-ks.com** ose plotësoni formularin e kontaktit — do t'ju përgjigjemi sa më shpejt.";
}

function parseMarkdown(text) {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part,
  );
}

export default function ChatBot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Mirë se vini! Jam TechBot, asistenti virtual i TechTalent. Si mund t'ju ndihmoj sot?",
    },
  ]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  function send(text) {
    const trimmed = (text || input).trim();
    if (!trimmed) return;

    setMessages((prev) => [...prev, { from: "user", text: trimmed }]);
    setInput("");
    setTyping(true);

    setTimeout(() => {
      const reply = getReply(trimmed);
      setTyping(false);
      setMessages((prev) => [...prev, { from: "bot", text: reply }]);
    }, 700);
  }

  function handleKey(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  }

  return (
    <>
      {/* Floating toggle button */}
      <button
        className="chatbot-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Mbyll chatbot" : "Hap chatbot"}
      >
        {open ? <FaTimes /> : <FaComments />}
        {!open && <span className="chatbot-toggle-badge" aria-hidden="true" />}
      </button>

      {/* Chat window */}
      {open && (
        <div className="chatbot-window" role="dialog" aria-label="TechBot chat">
          {/* Header */}
          <div className="chatbot-header">
            <span className="chatbot-avatar" aria-hidden="true">
              <FaRobot />
            </span>
            <div className="chatbot-header-info">
              <strong>{BOT_NAME}</strong>
              <span>TechTalent · Online</span>
            </div>
            <button
              className="chatbot-close"
              onClick={() => setOpen(false)}
              aria-label="Mbyll"
            >
              <FaTimes />
            </button>
          </div>

          {/* Messages */}
          <div className="chatbot-body">
            {messages.map((msg, i) => (
              <div key={i} className={`chatbot-msg chatbot-msg--${msg.from}`}>
                {parseMarkdown(msg.text)}
              </div>
            ))}
            {typing && (
              <div className="chatbot-msg chatbot-msg--bot chatbot-typing">
                <span />
                <span />
                <span />
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Suggestions */}
          {messages.length <= 2 && (
            <div className="chatbot-suggestions-wrapper">
              <p className="chatbot-suggestions-label">Pyetjet më të shpeshta</p>
              <div className="chatbot-suggestions">
                {SUGGESTIONS.map((s) => (
                  <button key={s} onClick={() => send(s)}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Input */}
          <div className="chatbot-footer">
            <input
              ref={inputRef}
              type="text"
              placeholder="Shkruani pyetjen tuaj…"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKey}
              maxLength={300}
            />
            <button
              onClick={() => send()}
              disabled={!input.trim()}
              aria-label="Dërgo"
            >
              <FaPaperPlane />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
